export function allPropsNull<T extends Record<string, unknown>>(obj: T): boolean {
  return (Object.keys(obj) as (keyof T)[]).every((key) => obj[key] === null);
}
